import { useMutation } from '@tanstack/react-query';
import toolsApiClient from '../clients/tools-api/tools-api.client';

export const usePostUserQuestion = () => {
  return useMutation<string, string, { name: string; question: string }>({
    mutationKey: ['post-user-question'],
    mutationFn: async ({ name, question }) => {
      if (!name || !question) {
        throw new Error('name and question are required');
      }

      return toolsApiClient.postUserQuestion(name, question);
    },
  });
};
